import React from 'react';

function LightningIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_332_7519)">
        <path d="M8.66667 1.3335L2 9.3335H8L7.33333 14.6668L14 6.66683H8L8.66667 1.3335Z" stroke="#2C2C2C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_332_7519">
          <rect width="16" height="16" fill="white" transform="translate(0 0.000244141)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default LightningIcon;
